<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/catalogs')" style="cursor: pointer">Catálogos</li>
        <li class="breadcrumb-item active" aria-current="page">Grupos de Productos</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <md-card>
            <md-card-header>
              <div class="md-title">Grupos de Productos
                <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="editGroup='New'">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head>ID</md-table-head>
                  <md-table-head>Grupo de Familia</md-table-head>
                  <md-table-head>Nombre</md-table-head>
                  <md-table-head>Descripción</md-table-head>
                  <md-table-head>Unidades de Capacidad</md-table-head>
                  <md-table-head>Impacto de Recurso Req.</md-table-head>
                  <md-table-head>Unidades Impacto de Recurso</md-table-head>
                  <md-table-head>Vida Útil Req.</md-table-head>
                  <md-table-head>Degradación por Año Req.</md-table-head>
                  <md-table-head>Numeros de Serie Req.</md-table-head>
                  <md-table-head style="text-align: center">Editar | Borrar</md-table-head>
                </md-table-row>
                <md-table-row v-if="editGroup==='New'">
                  <md-table-cell>{{editGroup}}</md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Grupo de Familia</label>
                      <md-select v-model="family_group">
                        <md-option :value="fg.id" v-for="fg in family_groups" :key="fg.id">{{fg.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Nombre</label>
                      <md-textarea v-model="name" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Descripción</label>
                      <md-textarea v-model="description" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Unidades de Capacidad</label>
                      <md-select v-model="capacity_units">
                        <md-option :value="cu" v-for="cu in capacity_units_list" :key="cu">{{cu}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="resource_impact_required"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Unidades Impacto de Recurso</label>
                      <md-textarea v-model="resource_impact_units" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="lifespan_required"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="degradation_per_year_required"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="serial_numbers_required"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell style="width: 16%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarGroup()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-for="product_group in product_groups" :key="product_group.id">
                  <md-table-cell>{{product_group.id}}</md-table-cell>

                  <md-table-cell v-if="editGroup===product_group.id">
                    <md-field>
                      <label>Grupo de Familia</label>
                      <md-select v-model="family_group">
                        <md-option :value="fg.id" v-for="fg in family_groups" :key="fg.id">{{fg.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{product_group.family_group}}</md-table-cell>

                  <md-table-cell v-if="editGroup===product_group.id">
                    <md-field>
                      <label>Nombre</label>
                      <md-textarea v-model="name" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{product_group.name}}</md-table-cell>

                  <md-table-cell v-if="editGroup===product_group.id">
                    <md-field>
                      <label>Descripción</label>
                      <md-textarea v-model="description" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{product_group.description}}</md-table-cell>

                  <md-table-cell v-if="editGroup===product_group.id">
                    <md-field>
                      <label>Unidades de Capacidad</label>
                      <md-select v-model="capacity_units">
                        <md-option :value="cu" v-for="cu in capacity_units_list" :key="cu">{{cu}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{product_group.capacity_units}}</md-table-cell>

                  <md-table-cell style="text-align: center" v-if="editGroup===product_group.id">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="resource_impact_required"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell v-else style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="product_group.resource_impact_required" disabled/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell v-if="editGroup===product_group.id">
                    <md-field>
                      <label>Unidades Impacto de Recurso</label>
                      <md-textarea v-model="resource_impact_units" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{product_group.resource_impact_units}}</md-table-cell>

                  <md-table-cell style="text-align: center" v-if="editGroup===product_group.id">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="lifespan_required"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell v-else style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="product_group.lifespan_required" disabled/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell style="text-align: center" v-if="editGroup===product_group.id">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="degradation_per_year_required"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell v-else style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="product_group.degradation_per_year_required" disabled/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell style="text-align: center" v-if="editGroup===product_group.id">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="serial_numbers_required"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell v-else style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="product_group.serial_numbers_required" disabled/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell style="width: 20%;text-align: center" v-if="editGroup===product_group.id">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarGroup()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                  <md-table-cell v-else style="width: 20%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised md-primary" v-on:click="editarGroup(product_group)">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="borrarGroup(product_group.id)">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">

  export default  {
    name: 'product-groups',
    props: [],
    mounted () {
      this.getProductGroups();
      axios.get( '/api/catalogs/family_groups').then(response => {
        this.family_groups = response.data.data;
      });
    },
    data () {
      return {
        product_groups: [],
        family_groups: [],
        capacity_units_list: [
          'W (watts)','lt (litros)','m3 (metros cúbicos)','tr (toneladas de refrigeración)','N/A','otro'
        ],
        editGroup: null,
        family_group: null,
        name: null,
        description: null,
        capacity_units: null,
        resource_impact_required: null,
        resource_impact_units: null,
        lifespan_required: null,
        degradation_per_year_required: null,
        serial_numbers_required: null
      }
    },
    methods: {
      limpiar(){
        this.editGroup = null;
        this.family_group = null;
        this.name = null;
        this.description = null;
        this.capacity_units = null;
        this.resource_impact_required = null;
        this.resource_impact_units = null;
        this.lifespan_required = null;
        this.degradation_per_year_required = null;
        this.serial_numbers_required = null;
      },
      getProductGroups(){
        axios.get( '/api/catalogs/product_groups').then(response => {
          this.product_groups = response.data.data;
        });
      },
      guardarGroup(){
        Vue.toasted.show('Guardando Grupo de Productos...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/product_groups/save', {
          'product_group_id': this.editGroup === 'New' ? -1 : this.editGroup,
          'family_group_id': this.family_group,
          'name': this.name,
          'description': this.description,
          'capacity_units': this.capacity_units,
          'resource_impact_required': this.resource_impact_required,
          'resource_impact_units': this.resource_impact_units,
          'lifespan_required': this.lifespan_required,
          'degradation_per_year_required': this.degradation_per_year_required,
          'serial_numbers_required': this.serial_numbers_required,
        }).then(response => {
          this.limpiar();
          this.getProductGroups();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Grupo de Productos guardado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editarGroup(group){
        this.editGroup = group.id;
        this.family_group = group.family_group_id;
        this.name = group.name;
        this.description = group.description;
        this.capacity_units = group.capacity_units;
        this.resource_impact_required = group.resource_impact_required;
        this.resource_impact_units = group.resource_impact_units;
        this.lifespan_required = group.lifespan_required;
        this.degradation_per_year_required = group.degradation_per_year_required;
        this.serial_numbers_required = group.serial_numbers_required;
      },
      borrarGroup(gid){
        Vue.toasted.show('Borrando Grupo de Productos...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/product_groups/delete', {
          'product_group_id': gid,
        }).then(response => {
          this.getProductGroups();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Grupo de Productos borrado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
    },
    computed: {

    }
}

</script>

<style scoped>
  /* Customize the label (the container) */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 35px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    margin-left: 30%;
    border-radius: 30px;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: rgb(243, 205, 33);
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>
